import React from 'react';
import Price from '../Price/Price';
import accounting from 'accounting';
import './Threshold.scss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

const Threshold = ({ threshold, subTotal, primaryColor, shippingCost }) => {
  const freeShippingPrice = Math.max(0, (threshold - subTotal).toFixed(2));
  const freeShippingPercent = !shippingCost
    ? 100
    : Math.min(100, ((subTotal / threshold) * 100).toFixed(2));

  const thresholdStyle = {
    '--primary-color': primaryColor,
  };

  return (
    <div className="cart-threshold" style={thresholdStyle}>
      {freeShippingPercent !== 100 ? (
        <p>
          Stai per raggiungere la consegna gratuita. Aggiungi al carrello altri
          prodotti per non pagare la spedizione.
        </p>
      ) : (
        <p>
          Complimenti! Hai raggiunto la soglia per la spedizione gratuita. Non
          devi preoccuparti dei costi di spedizione.
        </p>
      )}

      <div className="cart-threshold-head">
        {freeShippingPercent !== 100 ? (
          <Price className="cart-threshold-price" amount={subTotal} />
        ) : null}
        {freeShippingPercent !== 100 ? (
          <p className="cart-freeShippingPrice">
            Ancora € <b>{freeShippingPrice}</b> per la spedizione gratuita
          </p>
        ) : (
          ''
        )}
      </div>
      <div className="cart-threshold-percent">
        <div
          className={`loading-bar ${
            freeShippingPercent === 100 ? 'complete' : ''
          }`}
          style={{ width: `${freeShippingPercent}%`, borderRadius: '5px' }}
        ></div>
      </div>
      <div className="cart-threshold-footer">
        {freeShippingPercent >= 100 ? (
          <p>Spedizione gratuita</p>
        ) : (
          <p>
            Il tuo carrello è pieno al <b>{freeShippingPercent}%</b> per la
            spedizione gratuita
          </p>
        )}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    primaryColor: state.store.data.loghiTemplate.brandColor,
  };
}

export default withRouter(connect(mapStateToProps, {})(Threshold));
